interface TeamTabsProps {
  active: 'operations' | 'installation'
  onChange: (team: 'operations' | 'installation') => void
}

export function TeamTabs({ active, onChange }: TeamTabsProps) {
  return (
    <nav className="team-tabs" aria-label="Team">
      <button
        type="button"
        className={`team-tab ${active === 'operations' ? 'team-tab--active' : ''}`}
        onClick={() => onChange('operations')}
      >
        Operations
      </button>
      <button
        type="button"
        className={`team-tab ${active === 'installation' ? 'team-tab--active' : ''}`}
        onClick={() => onChange('installation')}
      >
        Installation
      </button>
    </nav>
  )
}
